import { GatePassageNotificationStore } from '@planning/stores/gateClerk/GatePassageNotificationStore'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

interface IProps {
  store: GatePassageNotificationStore
}

// Gate-out mismatch resolution per tenant mode: Warn asks the clerk to confirm exiting at
// the wrong gate (designated gate is kept); Block only proceeds by correcting the
// designated exit gate to the current gate. Cancelling either leaves the truck on terminal.
export const ExitGateMismatchDialog: FC<IProps> = observer(({ store }) => {
  const { t } = useTranslate()

  const mismatch = store.exitGateMismatch
  const designatedGateLabel =
    mismatch?.designatedExitGateCode ||
    mismatch?.designatedExitGateName ||
    mismatch?.designatedExitGateId ||
    ''

  return (
    <>
      <ConfirmationDialog
        open={mismatch?.mode === 'warn'}
        title={t('wrongExitGate', 'Wrong exit gate')}
        message={t(
          'exitGateMismatchWarning',
          'Truck {licensePlate} is designated to exit at gate {gate}. Gate out here anyway? The designated exit gate will be kept.',
          { licensePlate: store.licensePlate ?? '', gate: designatedGateLabel },
        )}
        primaryActionText={t('gateOut', 'Gate out')}
        closeLabel={t('cancel', 'Cancel')}
        onConfirm={store.resolveExitGateMismatch}
        onClose={store.dismissExitGateMismatch}
        mobile
      />

      <ConfirmationDialog
        open={mismatch?.mode === 'block'}
        title={t('wrongExitGate', 'Wrong exit gate')}
        message={t(
          'exitGateMismatchBlocked',
          'Truck {licensePlate} must exit at gate {gate}. To gate out here, the designated exit gate will be changed to this gate.',
          { licensePlate: store.licensePlate ?? '', gate: designatedGateLabel },
        )}
        primaryActionText={t('changeGateAndGateOut', 'Change gate & gate out')}
        closeLabel={t('cancel', 'Cancel')}
        onConfirm={store.resolveExitGateMismatch}
        onClose={store.dismissExitGateMismatch}
        mobile
      />
    </>
  )
})
